import React from 'react'

/**
 * @param  {string} disclaimerText
 */
const Disclaimer = ({ disclaimerText }) => {
    return (
        <p className='calc-disc' data-testid='disclaimer-text'>
            <strong>Disclaimer:</strong> {disclaimerText}
        </p>
    )
}

export { Disclaimer }
